import GalleryPlaceholderDesktop from './galleryPlaceholderDesktop.png';
import GalleryPlaceholderMobile from './galleryPlaceholderMobile.png';
import GalleryPlaceholderTablet from './galleryPlaceholderTablet.png';
import GalleryPlaceholderDesktopWebp from './galleryPlaceholderDesktop.webp';
import GalleryPlaceholderMobileWebp from './galleryPlaceholderMobile.webp';
import GalleryPlaceholderTabletWebp from './galleryPlaceholderTablet.webp';
import ListviewEmptyGraphic from './listviewEmpty.svg';
import ListviewEmptyFishGraphic from './listviewEmptyFish.svg';
import ListviewEmptySubmarineGraphic from './listviewEmptySubmarine.svg';

export {
  GalleryPlaceholderTablet,
  GalleryPlaceholderMobile,
  GalleryPlaceholderDesktop,
  ListviewEmptyGraphic,
  ListviewEmptyFishGraphic,
  ListviewEmptySubmarineGraphic,
  GalleryPlaceholderDesktopWebp,
  GalleryPlaceholderMobileWebp,
  GalleryPlaceholderTabletWebp,
};
